import React, { useState } from "react";

import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import { Nav } from "react-bootstrap";
import JSZipUtils from "jszip-utils";
import JSZip from "jszip";
import FileSaver from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import {
  addSurvey,
  deleteSurvey,
  publishSurvey,
  requestReports,
  surveySelector,
} from "../../../redux/surveySlice";

import { useNavigate } from "react-router-dom";
import EditSurvey from "../../dashboardHome/EditSurvey";
import { error, success } from "../../../redux/notificationSlice";
import {
  closeEditSurveyModal,
  modalSelector,
  openEditSurveyModal,
} from "../../../redux/modalSlice";
import { api } from "../../../services/api-service";
import axios from "axios";
import fileDownload from "js-file-download";

const SurveyLinks = () => {
  const survey = useSelector(surveySelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { modal } = useSelector(modalSelector);

  const download = () => {
    let links = [];
    if (survey.inspection) {
      survey.inspection.forEach((element) => {
        if (element.photos) {
          element.photos.forEach((photo) => {
            links.push(photo);
          });
        }
      });
    }
    if (links.length === 0) {
      dispatch(error("No media in this survey"));
      return;
    }
    var zip = new JSZip();
    var count = 0;
    var zipFilename = `${survey.hdcAssetReference}.zip`;
    links.forEach(function (url, i) {
      var filename = links[i].split("/");
      filename = filename[filename.length - 1];
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          throw err;
        }
        zip.file(filename, data, { binary: true });
        count++;
        if (count == links.length) {
          zip.generateAsync({ type: "blob" }).then(function (content) {
            FileSaver.saveAs(content, zipFilename);
          });
        }
      });
    });
  };

  const publish = async () => {
    dispatch(publishSurvey(survey));
  };

  const downloadReport = async () => {
    if (survey.status === "draft") {
      dispatch(
        error("Report cannot be generated as survey is not submitted yet.")
      );
      return;
    }
    const response = await api.post(`download-report/${survey.id}`);
    if (response?.ok) {
      axios
        .get(response.data.data, {
          responseType: "blob",
        })
        .then((res) => {
          fileDownload(res.data, survey.hdcAssetReference + ".pdf");
        });
    }
  };

  const surveyDelete = async () => {
    await dispatch(deleteSurvey(survey));
    navigate("/surveys");
  };

  return (
    <>
      <Nav className="justify-content-end cta_rounded">
        <Dropdown className="nav-item" align="end">
          <Dropdown.Toggle className="nav-link">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5613 15.6611L12.5613 3.62012"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.4773 12.7334L12.5613 15.6614L9.6453 12.7334"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.194 8.35303H18.127C20.162 8.35303 21.811 10.002 21.811 12.038V16.922C21.811 18.952 20.166 20.597 18.136 20.597L6.99604 20.597C4.96104 20.597 3.31104 18.947 3.31104 16.912V12.027C3.31104 9.99803 4.95704 8.35303 6.98604 8.35303L7.92803 8.35303"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item href="#" onClick={() => downloadReport()}>
              Download Report
            </Dropdown.Item>
            <Dropdown.Item href="" onClick={() => download()}>
              Download media files
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Nav.Item>
          <Nav.Link onClick={() => publish()}>
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.6959 2.98685H9.04387C6.96387 2.97885 5.25987 4.63585 5.20987 6.71585V17.4528C5.16487 19.5548 6.83287 21.2948 8.93387 21.3398C8.97087 21.3398 9.00787 21.3408 9.04387 21.3398H17.0319C19.1219 21.2658 20.7739 19.5438 20.7619 17.4528V8.26285L15.6959 2.98685Z"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.4341 2.9751V5.8841C15.4341 7.3041 16.5831 8.4551 18.0031 8.4591H20.7571"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.6001 10.1338V16.1748"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.9459 12.4893L12.6009 10.1343L10.2559 12.4893"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link onClick={() => surveyDelete()}>
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.8842 8.11511C16.8842 8.11511 16.4317 13.7276 16.1692 16.0918C16.0442 17.2209 15.3467 17.8826 14.2042 17.9034C12.03 17.9426 9.85335 17.9451 7.68002 17.8993C6.58085 17.8768 5.89502 17.2068 5.77252 16.0976C5.50835 13.7126 5.05835 8.11511 5.05835 8.11511"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.0369 5.42472H3.90527"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.314 5.42471C14.6598 5.42471 14.0965 4.96221 13.9682 4.32138L13.7657 3.30805C13.6407 2.84055 13.2173 2.51721 12.7348 2.51721H9.20734C8.72484 2.51721 8.30151 2.84055 8.17651 3.30805L7.97401 4.32138C7.84567 4.96221 7.28234 5.42471 6.62817 5.42471"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            onClick={() => {
              dispatch(openEditSurveyModal());
              dispatch(
                addSurvey({ ...survey, wheRef: survey?.wheRef.split("/")[1] })
              );
            }}
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.87729 2.54919H6.76145C4.19895 2.54919 2.59229 4.36336 2.59229 6.93169V13.86C2.59229 16.4284 4.19145 18.2425 6.76145 18.2425H14.1148C16.6856 18.2425 18.2848 16.4284 18.2848 13.86V10.5034"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.65682 9.32572L13.8843 3.09822C14.6601 2.32322 15.9176 2.32322 16.6935 3.09822L17.7076 4.11238C18.4835 4.88822 18.4835 6.14655 17.7076 6.92155L11.4501 13.1791C11.111 13.5182 10.651 13.7091 10.171 13.7091H7.04932L7.12765 10.5591C7.13932 10.0957 7.32848 9.65405 7.65682 9.32572Z"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.938 4.06042L16.743 7.86542"
                stroke="#338585"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <EditSurvey
        show={modal.editSurvey}
        onHide={() => dispatch(closeEditSurveyModal())}
      />
    </>
  );
};

export default SurveyLinks;
